import * as apiClient from '../../common/ApiClient/ApiClient'

export const getSeller = (sellerId) => {
    return apiClient.getSeller(sellerId)
        .then(response => response)
        .catch(error => Promise.reject(error))
}


// WEBPACK FOOTER //
// ./src/components/Seller/SellerService.jsx